import Input from "../form/input/InputField";

interface Props {
  sourceOptions: [string, string][];
  bookingSource: string;
  fromDate: string;
  toDate: string;
  customerEmail: string;
  sessionId: string;
  onBookingSourceChange: (value: string) => void;
  onFromDateChange: (value: string) => void;
  onToDateChange: (value: string) => void;
  onCustomerEmailChange: (value: string) => void;
  onSessionIdChange: (value: string) => void;
  onRefresh: () => void;
  loading?: boolean;
}

export default function BookingFormAuditServerFilters({
  sourceOptions,
  bookingSource,
  fromDate,
  toDate,
  customerEmail,
  sessionId,
  onBookingSourceChange,
  onFromDateChange,
  onToDateChange,
  onCustomerEmailChange,
  onSessionIdChange,
  onRefresh,
  loading = false,
}: Props) {
  return (
    <div className="mb-6 rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
      <div className="flex flex-wrap items-center gap-3">
        <select
          value={bookingSource}
          onChange={(e) => onBookingSourceChange(e.target.value)}
          className="h-11 w-full min-w-[11rem] max-w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 dark:border-gray-700 dark:text-white/90 sm:w-auto"
        >
          <option value="">All websites</option>
          {sourceOptions.map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        <div className="w-[10.5rem]">
          <Input
            type="date"
            placeholder="From date"
            value={fromDate}
            onChange={(e) => onFromDateChange(e.target.value)}
          />
        </div>
        <div className="w-[10.5rem]">
          <Input
            type="date"
            placeholder="To date"
            value={toDate}
            onChange={(e) => onToDateChange(e.target.value)}
          />
        </div>
        <div className="min-w-[12rem] w-52 max-w-full">
          <Input
            placeholder="Customer email"
            value={customerEmail}
            onChange={(e) => onCustomerEmailChange(e.target.value)}
          />
        </div>
        <div className="min-w-[10rem] w-44 max-w-full">
          <Input
            placeholder="Session ID"
            value={sessionId}
            onChange={(e) => onSessionIdChange(e.target.value)}
          />
        </div>
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="h-11 shrink-0 rounded-lg bg-brand-500 px-4 text-sm font-medium text-white hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? "Loading…" : "Refresh"}
        </button>
      </div>
    </div>
  );
}
